import React from "react";
import { SurveyQuestionOption } from "./surveyQuestions";
import { Box, Radio, Stack, Typography } from "@mui/material";
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import SurveyQuestionThumbnail from "./surveyQuestionThumbnail";

type SurveyQuestionMultiChoiceProps = {
    options: SurveyQuestionOption[];
    selected: string | null;
    setSelected: (value: string) => void;
    showPreviouslySelected?: boolean;
};

const SurveyQuestionMultiChoice: React.FC<SurveyQuestionMultiChoiceProps> = ({
    options,
    selected,
    setSelected,
    showPreviouslySelected = false,
}) => {
    const showAsColumn = window.innerWidth < 768 || options.length <= 5;
    const optionWidth =
        window.innerWidth < 468
            ? "100%"
            : window.innerWidth < 700
                ? "75%"
                : showAsColumn
                    ? "50%"
                    : "100%";

    return (
        <Box
            sx={{
                display: 'grid',
                gridTemplateColumns: showAsColumn ? '1fr' : '1fr 1fr',
                gap: 2,
                mt: 2,
                justifyItems: 'center',
            }}
        >
            {options.map((option) => (
                <Stack
                    key={option.label}
                    direction="column"
                    spacing={0.5}
                    sx={{
                        p: 1,
                        width: optionWidth,
                        border:
                            selected === option.value
                                ? "2px solid #355ADD"
                                : "2px solid transparent",
                        borderRadius: "5px",
                        cursor: "pointer",
                    }}
                    onClick={() => setSelected(option.value)}
                >
                    <Stack direction="row" alignItems="center" spacing={1}>
                        <Radio
                            value={option.value}
                            checked={selected === option.value}
                            onChange={() => setSelected(option.value)}
                            icon={<RadioButtonUncheckedIcon sx={{ color: '#355ADD' }} />}
                            checkedIcon={<RadioButtonCheckedIcon sx={{ color: '#355ADD' }} />}
                        />
                        {option.thumbnail && window.innerWidth > 350 && (
                            <SurveyQuestionThumbnail
                                size={window.innerWidth <= 500 ? "small" : "medium"}
                                src={option.thumbnail}
                                alt={option.value}
                            />
                        )}
                        <Box>
                            <Typography
                                sx={{ fontWeight: "bold", userSelect: "none" }}
                                color="#355ADD"
                            >
                                {option.label}
                            </Typography>

                            {showPreviouslySelected && selected === option.value && (
                                <Box
                                    sx={{
                                        display: "inline-block",
                                        mt: "2px",
                                        backgroundColor: "#355ADD",
                                        color: "#fff",
                                        fontSize: "11px",
                                        px: 1,
                                        py: 0.25,
                                        borderRadius: "6px",
                                        width: "fit-content",
                                    }}
                                >
                                    Previously Selected
                                </Box>
                            )}
                        </Box>
                    </Stack>
                </Stack>
            ))}
        </Box>
    );
};

export default SurveyQuestionMultiChoice;